import React from "react";
import { useParams, Link, Navigate } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { useLang } from "../lib/i18n";

export default function BlogDetail() {
  const { slug } = useParams();
  const { t } = useLang();
  const post = t.blog.posts.find((p) => p.slug === slug);

  if (!post) return <Navigate to="/blog" replace />;

  return (
    <article data-testid="blog-detail-page" className="container-x pt-8 pb-24 md:pb-32 max-w-4xl">
      <Link to="/blog" data-testid="back-to-blog" className="inline-flex items-center gap-1.5 text-sm text-ink/65 hover:text-ink mb-10">
        <ArrowLeft className="w-4 h-4" strokeWidth={1.5} />
        {t.nav.blog}
      </Link>

      <div className="flex items-center gap-3 text-xs uppercase tracking-[0.22em]">
        <span className="text-terracotta-400 font-medium">{post.category}</span>
        <span className="text-ink/40">·</span>
        <span className="text-ink/50">{post.date}</span>
      </div>
      <h1 className="mt-5 font-serif text-4xl md:text-6xl leading-[1.05] tracking-tight text-ink">{post.title}</h1>
      <p className="mt-5 text-lg text-ink/65 font-light">— {post.author}</p>

      <div className="mt-10 aspect-[16/9] rounded-3xl overflow-hidden">
        <img src={post.img} alt={post.title} className="w-full h-full object-cover" />
      </div>

      <div className="mt-12 space-y-6">
        <p className="font-serif italic text-2xl md:text-3xl text-ink/85 leading-snug">
          {post.excerpt}
        </p>
        {post.body.map((para, i) => (
          <p key={i} className="text-lg md:text-xl text-ink/75 font-light leading-relaxed">
            {para}
          </p>
        ))}
      </div>

      <div className="mt-16 pt-10 border-t border-cream-300/70 flex items-center justify-between">
        <Link to="/blog" data-testid="blog-detail-back" className="inline-flex items-center gap-1.5 text-sm text-ink/65 hover:text-ink">
          <ArrowLeft className="w-4 h-4" strokeWidth={1.5} />
          {t.nav.blog}
        </Link>
        <Link to="/contact" data-testid="blog-detail-contact" className="inline-flex items-center gap-2 text-sm font-medium text-ink hover:text-terracotta-400">
          {t.common.getInTouch}
          <ArrowRight className="w-4 h-4" strokeWidth={1.5} />
        </Link>
      </div>
    </article>
  );
}
